<div class="flex items-center justify-center dialog-header ">
    Update Group

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">

    <div class="font-medium text-sm mb-1">
        Update Group Name
    </div>
    <input type="text" 
    class="w-full"
    pInputText [(ngModel)]="groupName" />

    <div class="flex justify-end gap-4 mt-7">
        <p-button [label]="'Cancel'"  variant="outlined" severity="danger"
            (click)="handleCloseDialog()"></p-button>
        <p-button [label]="'Update'" [icon]="'pi pi-edit'" (click)="handleUpdateGroup()"
            [loading]="isLoading"></p-button>

    </div>

</div>